module.exports = __webpack_public_path__ + "img/pijltje-rechts-wit.e7e10cf8d8a48dd6dc2e15198d395ea9.svg";